import {Button} from "../../../../index";
import React from "react";
import FinaliseConfirm from "./FinaliseConfirm";
import {useViewerStore} from "../../../../../store/store";
import {ModuleMesh, RoofMesh} from "../../../../../@types/types";
import {getRoofModuleMeshes} from "../../Three-JS-Viewer/Controllers/Common";
import {addModulesToAllRoofsMaxFill} from "../../Three-JS-Viewer/Controllers/ModuleControl";
import {Alert} from "antd";
import {isDesignOriginalSite} from "../../../../../helpers/storeHelpers";

interface ModuleTypeChangeConfirmProps {
    selModule : any
}

const ModuleTypeChangeConfirm = (props: ModuleTypeChangeConfirmProps) => {

    const sceneViewer = useViewerStore(state => state.sceneViewer);

    const activeModule = useViewerStore((state) => state.activeModule);

    const isModuleTypeHaveDifferentPropertiesFromActive  = () => {
        return activeModule.power !== props.selModule?.power ||
            activeModule.w !== props.selModule.w ||
            activeModule.h !== props.selModule.h
    }

    const confirmModuleTypeChange = () => {

        useViewerStore.setState({activeModule: props.selModule});

        if (isModuleTypeHaveDifferentPropertiesFromActive()) {
            //Reset module layout to default
            addModulesToAllRoofsMaxFill(sceneViewer)
        } else {
            //Just change module type without resetting layout
            sceneViewer.roofs
            sceneViewer.roofs
                .flatMap((roof: RoofMesh) => roof.faces ?? [])
                .flatMap((face: RoofMesh) => face.moduleArr ?? [])
                .forEach((module: ModuleMesh) => module.selSize = props.selModule);

            sceneViewer.roofMeshArr
                .flatMap((roof: RoofMesh) => getRoofModuleMeshes(roof))
                .forEach((module: ModuleMesh) => module.selSize = props.selModule);

        }
        sceneViewer.removeViewerAlert()
    }

    const cancelModuleTypeChange = () => {
        sceneViewer.viewerAlert({show: false})
    }


    return (
        <>
            <p>You are about to change the module type to {props.selModule.text}.</p>
            <br/>
            {
                (props && isModuleTypeHaveDifferentPropertiesFromActive()) &&
                <>
                    <p>⚠️ This will reset the module layout to default on all roofs, any module layout changes done will be lost</p>
                    <br/>
                    <Alert
                        style={{ color: "black" }}
                        message="Note : This action cannot be undone.Confirm to proceed."
                        type="warning"
                        showIcon
                    />
                </>
            }
            <br/>
            <div className={"modal-bottom-action-button-container"}>

                <Button
                    variant="btn-primary"
                    size="btn-md"
                    className="editor__control--finalize modal-confirm-button"
                    onClick={confirmModuleTypeChange}
                >
                    Confirm
                </Button>
                <Button
                    variant="btn-primary"
                    size="btn-md"
                    className="editor__control--finalize modal-cancel-button"
                    onClick={cancelModuleTypeChange}
                >
                    Cancel
                </Button>

            </div>
        </>
    )
}

export default ModuleTypeChangeConfirm;